export enum PropertyTypeEnum {
  HOUSE = 'house',
  APARTMENT = 'apartment',
}
